export default "__VITE_ASSET___TPGWurL__"